module.exports = __webpack_public_path__ + "static/media/citibike-logo.1bab5ffe.svg";